import CalendarMonth from './CalendarMonth.vue';

export default CalendarMonth;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/components/calendar/components/month/index.ts